containsDataFromLink